/**
 * Global event names used across the Doppler UI.
 */
import type { ChatListItem } from "../services/chatApi";

export const USER_FILES_UPDATED_EVENT = "user-files:updated";
export const CHAT_HISTORY_UPDATED_EVENT = "chat-history:updated";
export const CHAT_STREAMING_STATUS_EVENT = "chat-streaming:status";
export const UPLOAD_STATUS_EVENT = "upload:status";

export type ChatHistoryEventDetail =
	| { kind: "upsert"; chat: ChatListItem }
	| { kind: "title"; chatId: string; title: string };

/**
 * Detail carried by `UPLOAD_STATUS_EVENT`.
 *
 * The project is part of the payload on purpose. This used to be a bare
 * `{ isUploading: boolean }`, which is what made the deal-room spinner a single
 * shared flag: whichever folder upload finished first switched it off for every
 * upload still running. A listener must be able to tell WHICH deal room an
 * event is about and ref-count accordingly.
 */
export interface UploadStatusEventDetail {
	jobId: string;
	projectId: string;
	projectName: string;
	/** The deal-room folder the files land in — the spinner's row anchor. */
	folderId: number;
	isUploading: boolean;
}
